import * as React from 'react';
import { useIntl } from 'react-intl';
import { useRecoilState, useSetRecoilState } from 'recoil';
import { rideAutofocusAtom } from '../../RidePlayer/RidePlayerState';
import { autofocusAtom, vehicleFocusAtom, zoomAtom } from '../OnlineMapState';

const MIN_ZOOM = 3;
const MAX_ZOOM = 22;

interface IZoomToolbar {
  map: google.maps.Map;
}

export default function ZoomToolbar(props: IZoomToolbar) {
  const { formatMessage: f } = useIntl();
  const setRideAutofocus = useSetRecoilState<boolean>(rideAutofocusAtom);
  const [zoom, setZoom] = useRecoilState<number>(zoomAtom);
  const setAutofocus = useSetRecoilState<boolean>(autofocusAtom);
  const setVehicleFocus = useSetRecoilState<boolean>(vehicleFocusAtom);

  const handleSetZoom = (value: number) => {
    setAutofocus(false);
    setVehicleFocus(false);
    setRideAutofocus(false);
    setZoom(value);
    props.map.setZoom(value);
  };

  const handleZoomIn = (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
    event.preventDefault();
    const mapZoom = props.map.getZoom();
    if (mapZoom) {
      const zoomLevel = mapZoom + 1;
      handleSetZoom(zoomLevel >= MAX_ZOOM ? MAX_ZOOM : zoomLevel);
    }
  };

  const handleZoomOut = (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
    event.preventDefault();
    const mapZoom = props.map.getZoom();
    if (mapZoom) {
      const zoomLevel = mapZoom - 1;
      handleSetZoom(zoomLevel <= MIN_ZOOM ? MIN_ZOOM : zoomLevel);
    }
  };

  React.useMemo(() => {
    props.map.setOptions({
      minZoom: MIN_ZOOM,
      maxZoom: MAX_ZOOM,
    });
  }, [props.map]);

  React.useMemo(() => {
    if (props.map) {
      props.map.setZoom(zoom);
    }
  }, [props.map, zoom]);

  return (
    <div className="b-map-zoom-actions">
      <a
        id="zoom-in"
        className="e-button-sq"
        title={f({ id: 'map.zoomin' })}
        onClick={handleZoomIn}
      >
        <i className="cmd-icons cmd-icon-zoom-in" />
      </a>
      <a
        id="zoom-out"
        className="e-button-sq"
        title={f({ id: 'map.zoomout' })}
        onClick={handleZoomOut}
      >
        <i className="cmd-icons cmd-icon-zoom-out" />
      </a>
    </div>
  );
}
